import { useQueryParams } from "@certn/api";
import { Picker } from "@certn/cascadia-react";
import React from "react";
import { useTranslation } from "react-i18next";

export function StatusFilter() {
  const { getParamsAsArray, setParam } = useQueryParams();
  const { t } = useTranslation();
  const paramKey = "is_active";

  return (
    <Picker
      showActionBar
      selectedKeys={getParamsAsArray(paramKey)}
      onSelectionChange={(keys) =>
        setParam("is_active", Array.from(keys).map(String), true)
      }
      label={t("Status")}
      items={[
        {
          name: t("Active"),
          id: "true",
        },
        {
          name: t("Deactivated"),
          id: "false",
        },
      ]}
      selectionMode="multiple"
      testID="status-filter"
    />
  );
}
